import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-construction-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_459_2041)">
        <path
          d="M0.75 18.75H8.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.25 18.75H23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 14.25H8.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 9.75H11.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.75 5.25H2.25C1.85218 5.25 1.47064 5.40804 1.18934 5.68934C0.908035 5.97064 0.75 6.35218 0.75 6.75V21.75C0.75 22.1478 0.908035 22.5294 1.18934 22.8107C1.47064 23.092 1.85218 23.25 2.25 23.25H23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.4789 5.81442L18.186 6.52153C18.5765 6.91206 19.2096 6.91206 19.6002 6.52153L22.9589 3.16277C23.3495 2.77225 23.3495 2.13908 22.9589 1.74856L22.2518 1.04145C21.8613 0.650929 21.2281 0.650929 20.8376 1.04145L17.4789 4.40021C17.0883 4.79073 17.0883 5.4239 17.4789 5.81442Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.3 13.062L19.952 10.411C20.0914 10.2717 20.202 10.1063 20.2775 9.92422C20.3529 9.74216 20.3917 9.54703 20.3917 9.34997C20.3917 9.15291 20.3529 8.95777 20.2775 8.77572C20.202 8.59367 20.0914 8.42827 19.952 8.28897L17.8321 6.16797"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.5799 17.81C11.5258 17.9462 11.5127 18.0952 11.5423 18.2386C11.5719 18.3821 11.6429 18.5138 11.7465 18.6174C11.8501 18.721 11.9818 18.792 12.1253 18.8216C12.2687 18.8512 12.4178 18.8381 12.5539 18.784L19.5349 16.009C19.752 15.906 19.9413 15.7524 20.0867 15.561C20.232 15.3697 20.3293 15.1462 20.3703 14.9094C20.4112 14.6726 20.3947 14.4294 20.3221 14.2003C20.2494 13.9712 20.1228 13.7629 19.9529 13.593L16.7709 10.411C16.601 10.2411 16.3927 10.1145 16.1636 10.0418C15.9345 9.96919 15.6913 9.95267 15.4545 9.99364C15.2177 10.0346 14.9942 10.1319 14.8029 10.2773C14.6115 10.4226 14.4579 10.6119 14.3549 10.829L11.5799 17.81Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.25 14.25V18.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 9.75V14.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.75 5.25V9.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 18.75V23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 20.25V23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_459_2041">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class ConstructionInsuranceIconComponent extends BaseIconComponent {}
